/**
 * token 请求头附加
 *
 * @since 1.0.0
 * @version 1.0.0
 */

// 不需要验证权限的接口地址列表
const unAuth = []
/**
 * token请求头附加
 *
 * @param {object} config - http 配置参数
 * @returns {object} 返回更改后的config
 */
export default function tokenReqInterceptor(config) {
  // 设置token
  const token = window.sessionStorage.getItem('token') ? 'Basic ' + window.sessionStorage.getItem('token') : ''
  config.headers.Authorization = token
  config.headers.terminalSource = 3
  config.headers.appCode = 'saas_report' // 后期需要将appCode改成 saas_report
  config.headers.request_id = JSON.parse(sessionStorage.getItem('userInfo'))?.mobile + '_' + Date.now()

  // 添加 repeatToken 到请求头
  if (config.repeatToken) {
    config.headers.repeatToken = config.repeatToken
  }
  // 存在repeatToken, 兼容没传值的场景
  if ('repeatToken' in config.headers && !config.headers['repeatToken']) {
    delete config.headers['repeatToken']
  }

  return config
}
